/* eslint-disable */
import moment from "moment";
import { useSearchParams } from "react-router-dom";
import dayjs from "dayjs";
import SeparatedRowElements from "components/general/SeparatedRowElements";
import InfoRow from "components/general/InfoRow";
import Table from "components/general/Table";
import UserInfo from "components/cards/UserInfo";
import {
  useGetMyEmployeeShiftsQuery,
  useGetMyShiftsQuery,
} from "apis/services/shift";
import { AllStaffShiftsProps } from "apis/types/shift";
import { ShiftType } from "constants/ShiftType";
import formatTime from "utils/formatDateTime";
import IMPORTANT_VARS from "constants/ImportantVars";
import useGetUserInfo from "hooks/useGetUserInfo";
import StaffAction from "./StaffAction";
import TabHeader from "./TabHeader";
import styles from "./styles.module.scss";
import formateDate from "utils/formatDate";
import Button from "components/general/Button";
import { useState } from "react";
import ViewPunchesModal from "components/modals/ViewPunchesModal";
import usePermissions from "hooks/usePermission";

export default function Fixed({
  statisticts,
  isLoading,
  viewStatistics,
}: {
  statisticts?: any;
  isLoading?: boolean;
  viewStatistics: boolean;
}) {
  const [searchParams] = useSearchParams();
  const [isPunchesModalVisible, setIsPunchesModalVisible] = useState(false);
  const [selectedShift, setSelectedShift] = useState<AllStaffShiftsProps | null>(null);

  const { role } = useGetUserInfo();
  const { hasPermissionTo } = usePermissions();
  const canViewPunches = hasPermissionTo("view_punches");

  // const requestBasedOnRole =
  //   role === "employee" ? useGetMyShiftsQuery : useGetMyEmployeeShiftsQuery;

  const { data, isFetching: isEmployeeShiftsLoading } =
    useGetMyEmployeeShiftsQuery(
      {
        shift_type: ShiftType.Fixed,
        page: searchParams.get("page") ?? "1",
        search: searchParams.get("search") ?? "",
        type: searchParams.get("type") ?? "",
        start_date:
          searchParams.get("startDate") ??
          moment(new Date()).format("YYYY-MM-DD"),
        end_date: searchParams.get("endDate") ?? undefined,
        page_size: IMPORTANT_VARS.TabelDataPageSize,
        ordering: "date",
      },
      // Clearing a filter lands back on args that were already fetched once, so
      // without this the cached page is served and the list never re-asks.
      { refetchOnMountOrArgChange: true },
    );

  const INFOS = [
    {
      title: "Present Days",
      info: statisticts?.present ?? 0,
    },
    {
      title: "Off",
      info: statisticts?.off ?? 0,
    },
    {
      title: "Leaves",
      info: statisticts?.leaves ?? 0,
    },
    {
      title: "Absent",
      info: statisticts?.absent ?? 0,
    },
  ];

  const isWorkDay = (item: AllStaffShiftsProps) =>
    item?.specification === "work";

  const changeShiftData = (item: any): any => ({
    id: String(item.id),
    rowData: [
      {
        type: "element",
        dataItem: <UserInfo data={item?.employee} isTableCol />,
      },
      {
        type: "text",
        dataItem: `${item?.shift_name}`,
      },
      {
        type: "text",
        dataItem: isWorkDay(item) ? item?.specification : "off",
      },
      {
        type: "text",
        dataItem: isWorkDay(item) ? formatTime(item.start_time) : "off",
      },
      {
        type: "text",
        dataItem: moment(item.date).format("DD-MM-YYYY"),
      },
      {
        type: "text",
        dataItem: formateDate(
          item?.checkin?.checkin_time,
          "DD-MM-YYYY hh:mm A",
        ),
      },
      {
        type: "text",
        dataItem: formateDate(
          item?.checkin?.checkout_time,
          "DD-MM-YYYY hh:mm A",
        ),
      },
      {
        type: "text",
        // The column stays so the rows keep lining up with the headers, and
        // only the action goes when the punches endpoint is off limits.
        dataItem: canViewPunches ? (
          <Button
            type="button"
            isOutline
            onClick={() => {
              setSelectedShift(item);
              setIsPunchesModalVisible(true);
            }}
          >
            View Punches
          </Button>
        ) : (
          "-"
        ),
      },
      {
        type: "text",
        dataItem: isWorkDay(item)
          ? `${Math.abs(
              dayjs(item.end_time, "hh:mm:ss").diff(
                dayjs(item.start_time, "hh:mm:ss"),
                "hour",
              ),
            )} Hours`
          : "off",
      },
      {
        type: "element",
        dataItem: (
          <StaffAction
            shift={{
              ...item,
              // @ts-ignore
              working_hour: `${Math.abs(
                dayjs(item.end_time, "hh:mm:ss").diff(
                  dayjs(item.start_time, "hh:mm:ss"),
                  "hour",
                ),
              )}`,
              // @ts-ignore
              template_id: `${item?.fixed_shift_name} (${formatTime(
                item.start_time,
              )} - ${formatTime(item.end_time)})`,
            }}
            employee={item.employee}
            assignType="fixed"
          />
        ),
      },
    ],
  });

  return (
    <div className={styles.container}>
      <TabHeader shifType={ShiftType.Fixed} showRefreshBtn />

      <div className="my-4">
        {viewStatistics && (
          <SeparatedRowElements>
            {INFOS.map((item) => (
              <InfoRow
                key={item.title}
                title={item.title}
                info={`${item.info}`}
                isReverse
                infoFontSize={28}
                infoFontWeight="500"
              />
            ))}
          </SeparatedRowElements>
        )}
      </div>

      <div className="my-4">
        <Table
          isCheckBoxVisible
          showSearchFilter
          showTypeFilter
          isActionBtnVisible={role && role !== "employee"}
          headers={[
            "Members ID",
            "Shift Name",
            "Status",
            "Starting Time",
            "Date",
            "Check In",
            "Check Out",
            "Punches",
            "Working Hours",
            "",
          ]}
          data={
            data?.results.map((item: AllStaffShiftsProps) =>
              changeShiftData(item),
            ) ?? []
          }
          isLoading={isEmployeeShiftsLoading || isLoading}
          count={data?.count}
          pageSize={IMPORTANT_VARS.TabelDataPageSize}
        />
      </div>

      <ViewPunchesModal
        isVisible={isPunchesModalVisible}
        setIsVisible={setIsPunchesModalVisible}
        shift={selectedShift}
      />
    </div>
  );
}
